export default __webpack_public_path__ + "static/media/vocab.ce957dd2.png";